/* lp-404 — built by feral·landers. Edit landers/404/page.js, not this. */
(function(){"use strict";var LP_ROOT="#lp-404",LP_NAME="404";
/* ═══════════════════════════════════════════════════════════════════════════
   feral·landers — base.js
   Wrapped in one IIFE by kit/build.mjs, which also injects LP_ROOT and LP_NAME.
   A lander's own page.js runs after this and can use everything below.
   No framework, no modules — this is a theme asset and it has to run alone.
   ═══════════════════════════════════════════════════════════════════════════ */

var LP = {};
var root = document.querySelector(LP_ROOT);
if (!root) return;                       // the section is not on this page

var $  = function (sel, ctx) { return (ctx || root).querySelector(sel); };
var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };
var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var isPhone = function () { return window.matchMedia('(max-width: 989px)').matches; };

LP.root = root; LP.$ = $; LP.$$ = $$; LP.reduced = reduced; LP.isPhone = isPhone;

/* Everything the data bridge hands us came out of Shopify admin, where a product
   title legitimately contains & and quotes. Escape before it touches innerHTML. */
function esc(s) {
  return String(s == null ? '' : s)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
}
LP.esc = esc;

/* ── THE DATA BRIDGE ──────────────────────────────────────────────────────
   The ~30 lines of Liquid in the section shell emit live product data as JSON:
   variant ids, size labels, availability and PRICES ALREADY RENDERED BY THE
   SERVER in the visitor's market currency.
   🚨 Never format money in here. Shopify does not currency-convert a number you
   typed; the server's string is the only one that is definitely true, and a
   client that cannot convert must do nothing rather than show GBP.
   (part: server-honest-money-fx-upgrade)                                     */
LP.data = (function () {
  var el = document.getElementById('lp-' + LP_NAME + '-data');
  if (!el) return { products: {}, settings: {} };
  try { return JSON.parse(el.textContent); } catch (e) { return { products: {}, settings: {} }; }
})();
LP.product = function (key) { return LP.data.products && LP.data.products[key]; };

document.body.classList.add('lp-live');

/* ── PORTAL ───────────────────────────────────────────────────────────────
   🚨 The lander root sets `overflow-x: clip`, and in Safari ANY ancestor with
   overflow clip/hidden, a transform or a filter kills `position: fixed` — the
   element scrolls with the page. Invisible on desktop Chrome. So anything fixed
   is moved out to <body> before it is ever shown.
   (part: fixed-dock-outside-the-clip-ancestor · portal-overlay-to-body)      */
LP.portal = function (el) { if (el && el.parentNode !== document.body) document.body.appendChild(el); return el; };
$$('[data-lp-portal]').forEach(LP.portal);

/* ── THE THEME CHROME IS A MOVING TARGET ──────────────────────────────────
   Two stacked sticky layers (marquee at top:0, header at top:32px) and the group
   COLLAPSES on scroll: 105px at rest, 73px in motion. A hardcoded number is
   wrong half the time.
   🚨 The collapse is a CSS transition, so it finishes AFTER the last scroll
   event — one reading latches a stale value and a full-height band scrolls
   through the gap. Re-measure at ~200ms and ~500ms after scrolling stops.     */
(function chrome() {
  var group = document.querySelector('.shopify-section-group-header-group') ||
              document.querySelector('#shopify-section-header') ||
              document.querySelector('header');
  if (!group) return;
  var write = function () {
    var b = group.getBoundingClientRect().bottom;
    root.style.setProperty('--lp-chrome', Math.max(0, Math.round(b)) + 'px');
  };
  var t1, t2;
  var onScroll = function () {
    write();
    clearTimeout(t1); clearTimeout(t2);
    t1 = setTimeout(write, 200);
    t2 = setTimeout(write, 500);
  };
  write();
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll, { passive: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(write);
})();

/* ── REVEALS ──────────────────────────────────────────────────────────────
   Arms only once we know JS is alive, so a script failure leaves a readable
   page rather than a blank one. Nothing in the first viewport is armed: it
   would fade in on load, read as a slow page, and cost LCP on the one element
   that matters most.                                                          */
(function reveals() {
  var items = $$('.lp-rv');
  if (!items.length || !('IntersectionObserver' in window)) return;
  var fold = window.innerHeight;
  var below = items.filter(function (el) { return el.getBoundingClientRect().top > fold * 0.9; });
  if (!below.length) return;
  root.classList.add('is-armed');
  items.forEach(function (el) { if (below.indexOf(el) < 0) el.classList.add('is-in'); });
  if (reduced) { below.forEach(function (el) { el.classList.add('is-in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      io.unobserve(e.target);
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.02 });
  below.forEach(function (el) { io.observe(el); });
})();

/* ── THE CART ─────────────────────────────────────────────────────────────
   The proven add-from-anywhere flow, lifted from assets/feral-plp.js.
   🚨 Send it FORM-ENCODED and ask for the drawer sections in the SAME request.
   A JSON body with {items:[…]} genuinely lands the line item and still leaves
   the drawer painting its cached empty state — /cart.js says the item is there
   while the drawer says BAG EMPTY. That is the signature of bypassing the
   section render. (part: cart-add-with-section-rerender)
   The Meta CAPI layer in snippets/feral-events.liquid patches window.fetch and
   fires AddToCart off /cart/add.js by itself — do not emit a second event.    */
var inflight = false;
LP.addToCart = function (items) {
  if (inflight) return Promise.resolve(null);
  inflight = true;
  var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  var fd = new FormData();
  items.forEach(function (it, i) {
    fd.append('items[' + i + '][id]', String(it.id));
    fd.append('items[' + i + '][quantity]', String(it.quantity || 1));
  });
  if (cart && typeof cart.getSectionsToRender === 'function') {
    fd.append('sections', cart.getSectionsToRender().map(function (s) { return s.id; }).join(','));
    fd.append('sections_url', window.location.pathname);
    if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
  }
  var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
  return fetch(url, {
    method: 'POST',
    headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
    body: fd
  })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      // Shopify returns a JSON body with `status` for a sold-out variant even
      // when the HTTP status is inconsistently 200.
      if (data.status) throw new Error(data.description || data.message || 'add failed');
      if (cart) {
        // Remove is-empty or the drawer keeps painting its empty state over
        // correct contents. Do NOT open the drawer by hand — renderContents
        // already opens it, and doing both fights the transition.
        if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        if (typeof cart.renderContents === 'function') cart.renderContents(data);
      }
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
        window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'lp-' + LP_NAME, cartData: data });
      }
      return data;
    })
    .finally(function () { inflight = false; });
};

/* ── THE SIZE SHEET ───────────────────────────────────────────────────────
   One sheet, portalled to <body>, populated per-call. Mobile gets a bottom
   sheet, desktop the same node centred (CSS decides) — a bottom sheet on a
   1440px screen is a modal for no reason, and an inline shake on a phone
   happens off-screen.
   The sold-out row stays FOCUSABLE and readable rather than disabled: a
   disabled control is invisible to a screen reader's tab order and throws away
   the most valuable moment on the page — someone who wants a thing you do not
   have. (part: the-buy-box-is-one-pill-in-three-states)                       */
var sheet, scrim, lastFocus;
function ensureSheet() {
  if (sheet) return;
  scrim = document.createElement('div');
  scrim.className = 'lp-sheet-scrim';
  sheet = document.createElement('div');
  sheet.className = 'lp-sheet';
  sheet.setAttribute('role', 'dialog');
  sheet.setAttribute('aria-modal', 'true');
  sheet.setAttribute('aria-label', 'Choose a size');
  document.body.appendChild(scrim);
  document.body.appendChild(sheet);
  scrim.addEventListener('click', closeSheet);
  addEventListener('keydown', function (e) { if (e.key === 'Escape') closeSheet(); });
}
function closeSheet() {
  if (!sheet) return;
  sheet.classList.remove('is-open');
  scrim.classList.remove('is-open');
  document.body.classList.remove('lp-locked');
  if (lastFocus && lastFocus.focus) lastFocus.focus();
}
LP.closeSheet = closeSheet;

/**
 * LP.pickSize(productKey, onPick) — onPick(variant) when a size is chosen.
 * Returns false and does nothing if the product is not in the data bridge.
 */
LP.pickSize = function (key, onPick) {
  var p = LP.product(key);
  if (!p) return false;
  ensureSheet();
  lastFocus = document.activeElement;
  var rows = p.variants.map(function (v) {
    var cls = 'lp-sheet__row' + (v.available ? '' : ' is-out');
    var right = v.available
      ? (v.low ? '<span class="lp-sheet__low">low stock</span>' : '')
      : '<span class="lp-sheet__out">sold out</span>';
    return '<button type="button" class="' + cls + '" data-vid="' + v.id + '"' +
           (v.available ? '' : ' data-out="1"') + '>' +
           '<span class="lp-sheet__size">' + esc(v.title) + '</span>' + right + '</button>';
  }).join('');
  sheet.innerHTML =
    '<div class="lp-sheet__head">' +
      '<div><div class="lp-sheet__eyebrow">' + esc(p.eyebrow) + '</div>' +
      '<div class="lp-sheet__title">' + esc(p.title) + '</div></div>' +
      '<button type="button" class="lp-sheet__x" aria-label="Close">&#10005;</button>' +
    '</div>' +
    '<div class="lp-sheet__grid">' + rows + '</div>' +
    '<a class="lp-sheet__link" href="' + esc(p.url) + '">Size guide and full detail &#8599;</a>';
  sheet.querySelector('.lp-sheet__x').addEventListener('click', closeSheet);
  Array.prototype.forEach.call(sheet.querySelectorAll('.lp-sheet__row'), function (b) {
    b.addEventListener('click', function () {
      if (b.getAttribute('data-out')) { window.location.href = p.url; return; }
      var v = p.variants.filter(function (x) { return String(x.id) === b.getAttribute('data-vid'); })[0];
      closeSheet();
      onPick(v);
    });
  });
  scrim.classList.add('is-open');
  sheet.classList.add('is-open');
  if (isPhone()) document.body.classList.add('lp-locked');
  // Focus the DIALOG, not the first size. `.focus()` on a row trips the
  // :focus-visible heuristics even from a tap, so the first size lights up with
  // a ring and reads as already chosen — on the one control where "nothing is
  // chosen yet" is the whole point. (part: size-deselected-until-the-url-picks-one)
  sheet.setAttribute('tabindex', '-1');
  sheet.focus();
  return true;
};

/* ── THE DOCK ─────────────────────────────────────────────────────────────
   Raised once the hero is behind you, so it never covers the first CTA.       */
LP.dockOn = function (afterEl) {
  var dock = document.querySelector('.lp-dock');   // portalled to <body>, so query the document
  if (!dock || !afterEl) return;
  if (!('IntersectionObserver' in window)) { dock.classList.add('is-up'); return; }
  new IntersectionObserver(function (e) {
    dock.classList.toggle('is-up', !e[0].isIntersecting);
  }, { threshold: 0 }).observe(afterEl);
};

/* Smooth in-page jumps that respect reduced motion. */
LP.jumpTo = function (el) {
  if (!el) return;
  el.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth', block: 'start' });
};
$$('[data-lp-jump]').forEach(function (a) {
  a.addEventListener('click', function (e) {
    var target = $(a.getAttribute('data-lp-jump'));
    if (!target) return;
    e.preventDefault();
    LP.jumpTo(target);
  });
});

window.LP = LP;

/* ═══════════════════════════════════════════════════════════════════════════
   404 — SLEEP NOT FOUND.  "THE SYSTEM" — page behaviour.
   Runs after kit/base.js, inside the same IIFE, so LP, $, $$ and root are live.

   THE RULE THIS FILE IS BUILT AROUND: every effect below is ADDED to a page
   that already reads. Nothing starts hidden, nothing starts blurred, no price
   is invented. A script error here costs the show, never the shop.
   ═══════════════════════════════════════════════════════════════════════════ */

var tee = LP.product('tee');
var hoodie = LP.product('hoodie');
var extras = LP.data.extras || {};
var docEl = document.documentElement;

/* ── PRICES ───────────────────────────────────────────────────────────────
   Every one of these was rendered by Liquid in the visitor's own market. The
   pair total too — `tee.price | plus: hoodie.price | money` — because adding
   two formatted strings, or formatting cents here, both quietly show a German
   customer GBP. If a value is missing the element keeps its em-dash rather
   than inventing a number.                                                   */
$$('[data-e-price]').concat(Array.prototype.slice.call(document.querySelectorAll('.lp-dock [data-e-price]')))
  .forEach(function (el) {
    var k = el.getAttribute('data-e-price');
    var v = k === 'pair' ? extras.pair : (LP.product(k) || {}).price;
    if (v) el.textContent = v;
  });

/* ── THE CHROME, MEASURED PROPERLY AND MIRRORED OUT TO <html> ─────────────
   🚨 MEASURED 2026-08-22 BY PROBE, and it is a kit bug, not a page bug:
   base.js takes `document.querySelector('.shopify-section-group-header-group')`
   — the FIRST match — and on this theme that is the MARQUEE, which every lander
   deliberately hides (`body.lp-live .feral-marquee-section{display:none}` in
   base.css). A hidden element's rect bottom is 0, so `--lp-chrome` computed
   `0px` on every load of every lander on this theme.

   It cost nothing visible until something was positioned off it: the error
   stream landed at y=14 and sat across the FERAL logo. In a screenshot that
   reads as a z-index mistake, which is the wrong thing to go and fix.

   So take the bottom-most VISIBLE header section rather than the first one, and
   write it BOTH places — onto the lander root, where the hero reads it, and
   onto <html>, where the portalled layers can. Raised for the kit separately;
   this is the local fix so the page is right either way.                     */
(function chrome() {
  var lastPx = '0px';
  var read = function () {
    var els = Array.prototype.slice.call(document.querySelectorAll(
      '.shopify-section-group-header-group, #shopify-section-header, body > header'));
    var bottom = 0;
    els.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.height > 0) bottom = Math.max(bottom, r.bottom);   // height 0 === hidden
    });
    var px = Math.max(0, Math.round(bottom)) + 'px';
    lastPx = px;
    root.style.setProperty('--lp-chrome', px);
  };

  /* 🚨 LAYOUT LATCHES, CHROME TRACKS — and that split IS the fix.
     A value used for LAYOUT may not track a value that changes on scroll. This
     is only ever latched at the top, where the header sits at its resting
     height and where changing the hero shifts nothing anybody can see.
     ⚠️ NOT on resize unconditionally: iOS fires `resize` when the URL bar
     collapses DURING a scroll, which would put the bug straight back.
     `scrollY < 4` is the whole guard. The toast offset keeps tracking live —
     it is positioned, not laid out, so moving it costs nothing. */
  var latch = function () {
    if (window.scrollY >= 4) return;
    root.style.setProperty('--e-chrome', lastPx);
    /* ⚠️ ON <html> AS WELL, and it is not belt-and-braces: the toast rail and
       the dock are PORTALLED to <body>, so they are outside #lp-404 and cannot
       read a variable set on it. */
    docEl.style.setProperty('--e-chrome', lastPx);
  };
  var settle = function () { read(); latch(); };

  var t1, t2;
  var onScroll = function () {
    read();
    // The theme's header group COLLAPSES on scroll and it is a CSS transition,
    // so it finishes after the last scroll event. One reading latches a stale
    // number. (Same reason base.js re-reads; kept here because this overwrites
    // the value base.js wrote.)
    clearTimeout(t1); clearTimeout(t2);
    /* ⚠️ THESE RE-READS HAVE TO RE-LATCH, and leaving them as bare read()s
       left half the bug in. Scrolling back to the top fires a scroll event
       while the header is still mid-transition, so the latch caught the
       COLLAPSED 73px and the hero came back 32px too tall — measured
       2026-08-27: doc 5,757 on the way down, 5,789 on the way back. The
       deferred reads are what see the settled header, so they are what has to
       write the layout value. It converges on the resting number, and the only
       thing that moves is a band of black padding at the fold. */
    t1 = setTimeout(settle, 200);
    t2 = setTimeout(settle, 500);
  };
  settle();
  addEventListener('scroll', onScroll, { passive: true });
  addEventListener('resize', onScroll, { passive: true });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(settle);
  setTimeout(settle, 900);
})();

/* ── THE CLOCK ────────────────────────────────────────────────────────────
   The dialog carries the visitor's OWN local time, live. It costs nothing and
   it is the whole difference between a printed graphic and a system that is
   talking to you — at 04:12 the joke lands by itself.                        */
(function clock() {
  var faces = $$('[data-e-clock]');
  if (!faces.length) return;
  function tick() {
    var d = new Date();
    var t = String(d.getHours()).padStart(2, '0') + ':' + String(d.getMinutes()).padStart(2, '0');
    faces.forEach(function (el) { el.textContent = t; });
  }
  tick();
  setInterval(tick, 20000);
})();

/* A heart rate that will not settle. Drifts inside a believable band, slowly —
   a number that changes every frame reads as a fake counter, and one that never
   changes reads as a picture.                                                 */
(function bpm() {
  var el = $('[data-e-bpm]');
  if (!el || LP.reduced) return;
  setInterval(function () {
    el.textContent = String(144 + Math.floor(Math.random() * 9));
  }, 2800);
})();

/* ── THE BOOT ─────────────────────────────────────────────────────────────
   Ref: the "encrypted transmission / integrity check in progress" film. The
   plate arrives coarse and the log types itself, then everything resolves.

   🚨 IT IS A RE-PLAY, NOT A RENDER. Both the log lines and the sharp photo are
   the page's RESTING state in the HTML; `e-boot` is added here to take them
   away and then hand them back. So the failure mode of this whole sequence is
   a page that was already finished.

   ⚠️ And it only runs while the document is still loading. On a bfcache
   restore the hero is already painted sharp, and snapping it to a blur to
   un-blur it is a glitch rather than an effect.                              */
(function boot() {
  var log = $('[data-e-boot]');
  if (!log || LP.reduced) return;
  if (document.readyState === 'complete') return;

  var lines = LP.$$('.e-log', log);
  root.classList.add('e-boot');

  var i = 0;
  var step = function () {
    if (i < lines.length) {
      lines[i].classList.add('is-on');
      i++;
      setTimeout(step, i < 3 ? 105 : 135);
      return;
    }
    // The photograph resolves as the log lands its verdict, not before it.
    root.classList.remove('e-boot');
  };
  setTimeout(step, 180);
})();

/* ── THE FRACTURE ─────────────────────────────────────────────────────────
   The numeral breaks, rarely. 280ms of displacement every 6-9 seconds — the ad
   taught this the expensive way: four passes strobed over the payoff was 16
   changes/sec against a 3/sec guideline, and it would have looked incredible
   and been rejected. Rare is what makes it read as a fault rather than a GIF.  */
(function fracture() {
  var el = $('[data-e-num]');
  if (!el || LP.reduced) return;
  var fire = function () {
    el.classList.add('is-glitch');
    setTimeout(function () { el.classList.remove('is-glitch'); }, 300);
    setTimeout(fire, 6000 + Math.random() * 3000);
  };
  setTimeout(fire, 2600);
})();

/* ── THE SCAN ─────────────────────────────────────────────────────────────
   One sweep, the first time the plate comes into view, then never again. A
   loop turns a diagnostic into a screensaver.                                */
(function scan() {
  var fig = $('[data-e-scan]');
  if (!fig || LP.reduced || !('IntersectionObserver' in window)) return;
  var io = new IntersectionObserver(function (entries) {
    if (!entries[0].isIntersecting) return;
    fig.classList.add('is-scanning');
    io.disconnect();
  }, { threshold: 0.35 });
  io.observe(fig);
})();

/* ── THE ERROR STREAM ─────────────────────────────────────────────────────
   The thing the ad did that Harry wanted here: errors that keep arriving.

   FOUR CONSTRAINTS, and they are what separate this from a page nobody can
   use. One every ~5.2s (the guideline is 3 CHANGES PER SECOND; this is two
   orders under it). Top edge only, offset by the measured header — never the
   bottom, because the dock lives there and covering the buy button with a joke
   is the one unforgivable version of this. aria-hidden, because a screen reader
   being interrupted every five seconds is not atmosphere. And gone entirely
   under prefers-reduced-motion, which the CSS enforces independently.         */
(function errors() {
  if (LP.reduced) return;

  var MSG = [
    ['e_sleep_not_found', 'sleep could not be located on this device.'],
    ['w_last_train', 'last train missed. no recovery path available.'],
    ['e_tomorrow', 'tomorrow.exe has stopped responding.'],
    ['w_battery_01', 'battery at 1%. the night continues regardless.'],
    ['i_sunrise', 'sunrise in 00:41. that is not a lot of runway.'],
    ['w_hydration', 'water not detected since 23:40.'],
    ['e_cloakroom', 'jacket in cloakroom. cloakroom closed.'],
    ['w_location', 'you are not where you said you would be.'],
    ['i_bpm', '148 bpm sustained for 4h 12m. no complaints logged.'],
    ['e_plans_0900', '09:00 plans flagged as optimistic.'],
    ['w_voice', 'voice.dll corrupted. shouting anyway.'],
    ['i_encore', 'one more tune requested six times.'],
    ['e_keys', 'keys located. phone missing. net zero.'],
    ['w_taxi', 'taxi is twelve minutes away. it has been for a while.'],
    ['i_friends', '4 of 5 friends accounted for.'],
    ['e_monday', 'monday not found. searching…']
  ];

  var wrap = document.createElement('div');
  wrap.id = 'lp404-toasts';
  wrap.setAttribute('aria-hidden', 'true');
  document.body.appendChild(wrap);

  /* ── NOT OVER SOMETHING THE VISITOR OPENED ──────────────────────────────
     Harry, 2026-08-22: the cart must never have a joke land on top of it.
     Generalised, because it is the same rule every time — an error toast is
     ATMOSPHERE, and atmosphere yields to anything the visitor deliberately
     opened. Read off the theme rather than guessed:

       cart drawer        <cart-drawer class="active">  + body.overflow-hidden
       cart notification  .cart-notification.active     (the INNER div, not the
                          custom element — cart-notification.js puts the class
                          on `this.notification`)
       nav drawer, modals body.overflow-hidden / .overflow-hidden-<breakpoint>
       our size sheet     .lp-sheet.is-open             + body.lp-locked

     `overflow-hidden` alone would cover most of it, but the drawer is also
     openable from the header on a page that never locked the body, so the
     element classes are checked too. */
  function overlayOpen() {
    if (/(^|\s)(overflow-hidden(-\w+)?|lp-locked)(\s|$)/.test(document.body.className)) return true;
    return !!document.querySelector(
      'cart-drawer.active, .cart-notification.active, .lp-sheet.is-open');
  }

  function hush() { while (wrap.firstChild) wrap.removeChild(wrap.firstChild); }
  LP.hush = hush;

  /* Guarding pop() only stops the NEXT toast. One already on screen when the
     cart slides out is the case Harry actually saw, so watch for the moment it
     opens and take it away. Narrow targets on purpose — body's own class, and
     the two cart elements' subtrees — rather than observing the whole document.
     🚨 `cart-drawer` may not exist yet on first paint, so re-resolve lazily. */
  if ('MutationObserver' in window) {
    var mo = new MutationObserver(function () { if (overlayOpen()) hush(); });
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    ['cart-drawer', 'cart-notification'].forEach(function (sel) {
      var el = document.querySelector(sel);
      if (el) mo.observe(el, { attributes: true, attributeFilter: ['class'], subtree: true });
    });
  }

  // Shuffled once, then walked in order — a random pick each time repeats
  // itself inside four draws and the repeat is the only thing anyone notices.
  var order = MSG.map(function (m, i) { return i; });
  for (var i = order.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var t = order[i]; order[i] = order[j]; order[j] = t;
  }

  var at = 0;
  function pop() {
    // Nothing lands on top of the cart, the size sheet or the nav.
    if (overlayOpen()) { hush(); return; }

    var cap = LP.isPhone() ? 1 : 2;
    while (wrap.children.length >= cap) wrap.removeChild(wrap.firstChild);

    var m = MSG[order[at % order.length]];
    at++;

    var el = document.createElement('div');
    el.className = 'lp404-toast';
    el.innerHTML = '<b></b><span><em>' + LP.esc(m[0]) + '</em><i>' + LP.esc(m[1]) + '</i></span>';
    wrap.appendChild(el);
    requestAnimationFrame(function () { el.classList.add('is-in'); });

    setTimeout(function () {
      el.classList.remove('is-in');
      setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 380);
    }, 5400);
  }

  // Late enough that the boot sequence owns the opening on its own.
  setTimeout(function () { pop(); setInterval(pop, 5200); }, 4200);
})();

/* ── STOCK ────────────────────────────────────────────────────────────────
   Honest, not urgent. It says "sold out" when a thing is gone and names the
   sizes that are low when they genuinely are — no counters, no invented
   scarcity, nothing that changes if you reload.                              */
function stockLine(p) {
  if (!p || !p.variants) return '';
  var out = p.variants.filter(function (v) { return !v.available; });
  var low = p.variants.filter(function (v) { return v.available && v.low; });
  if (out.length === p.variants.length) return 'sold out';
  if (out.length) return out.map(function (v) { return v.title; }).join(', ') + ' gone';
  if (low.length) return low.map(function (v) { return v.title; }).join(', ') + ' running low';
  return 'every size in stock';
}
$$('[data-e-stock]').forEach(function (el) {
  var p = LP.product(el.getAttribute('data-e-stock'));
  var line = stockLine(p);
  el.textContent = line;
  if (/gone|low|sold/.test(line)) el.setAttribute('data-low', '');
});

/* ── SIZE CHIPS in the control panel ──────────────────────────────────────
   Read-only: what exists and what is left. Choosing happens in the sheet.     */
$$('[data-e-sizes]').forEach(function (el) {
  var p = LP.product(el.getAttribute('data-e-sizes'));
  if (!p) return;
  el.innerHTML = p.variants.map(function (v) {
    return '<span class="e-size' + (v.available ? '' : ' is-out') + '">' + LP.esc(v.title) + '</span>';
  }).join('');
});

/* ── ADD ──────────────────────────────────────────────────────────────────
   One pill, three states, and the sold-out state stays pressable on purpose —
   it walks to the PDP where the back-in-stock capture lives, rather than being
   a dead control. (part: the-buy-box-is-one-pill-in-three-states)             */
function flash(btn, text, ok) {
  var was = btn.innerHTML;
  btn.innerHTML = text;
  btn.setAttribute('data-flash', ok ? 'ok' : 'err');
  setTimeout(function () { btn.innerHTML = was; btn.removeAttribute('data-flash'); }, 1600);
}

function addOne(key, btn) {
  var p = LP.product(key);
  if (!p) return;
  var anyLeft = p.variants.some(function (v) { return v.available; });
  if (!anyLeft) { window.location.href = p.url; return; }
  // Deterministic, and it does not wait on an observer: on desktop the sheet
  // does not lock the body, so this is the only signal that fires first.
  if (LP.hush) LP.hush();
  LP.pickSize(key, function (v) {
    LP.addToCart([{ id: v.id, quantity: 1 }])
      .then(function (d) { if (d) flash(btn, 'in the bag', true); })
      .catch(function () { flash(btn, 'try again', false); });
  });
}

$$('[data-e-add]').concat(Array.prototype.slice.call(document.querySelectorAll('.lp-dock [data-e-add]')))
  .forEach(function (btn) {
    btn.addEventListener('click', function () { addOne(btn.getAttribute('data-e-add'), btn); });
  });

/* ── THE PAIR ─────────────────────────────────────────────────────────────
   Two sizes, one after the other, then ONE /cart/add.js call carrying both
   line items. Measured on 4,569 paid orders (May–Aug 2026): a basket with a
   second item averages £144 against £74 for one. This is that number, made
   into a single tap — not a discount and not a bundle, which is why the copy
   says so plainly.                                                            */
var pairBtn = $('[data-e-pair]');
if (pairBtn && tee && hoodie) {
  pairBtn.addEventListener('click', function () {
    if (LP.hush) LP.hush();
    LP.pickSize('tee', function (v1) {
      // A beat, so the second sheet does not appear to be the same one failing
      // to close. Long enough to read as a step, short enough not to feel slow.
      setTimeout(function () {
        var opened = LP.pickSize('hoodie', function (v2) {
          LP.addToCart([{ id: v1.id, quantity: 1 }, { id: v2.id, quantity: 1 }])
            .then(function (d) { if (d) flash(pairBtn, 'both in the bag', true); })
            .catch(function () { flash(pairBtn, 'try again', false); });
        });
        if (opened) {
          var head = document.querySelector('.lp-sheet__head');
          if (head) {
            var step = document.createElement('div');
            step.className = 'lp-sheet__step';
            step.textContent = 'step 2 of 2 — the hoodie';
            head.parentNode.insertBefore(step, head);
          }
        }
      }, 260);
    });
    var head = document.querySelector('.lp-sheet__head');
    if (head) {
      var step = document.createElement('div');
      step.className = 'lp-sheet__step';
      step.textContent = 'step 1 of 2 — the tee';
      head.parentNode.insertBefore(step, head);
    }
  });
}

/* ── THE FEED RAIL ────────────────────────────────────────────────────────
   Its cells sit off to the RIGHT, so a vertical scroll never reveals them and
   they never load. Fetch them when the section arrives — not at page load,
   which is what `lazy` is protecting, and not on the swipe, which is too late. */
(function feedPreload() {
  var rail = $('.e-feed__rail');
  if (!rail) return;
  var wake = function () {
    LP.$$('img[loading="lazy"]', rail).forEach(function (i) { i.loading = 'eager'; });
  };
  if (!('IntersectionObserver' in window)) { wake(); return; }
  var io = new IntersectionObserver(function (e) {
    if (!e[0].isIntersecting) return;
    wake();
    io.disconnect();
  }, { rootMargin: '600px 0px' });
  io.observe(rail);
})();

/* ── THE DOCK ─────────────────────────────────────────────────────────────
   Up once the hero is behind you, so it never covers the first CTA.           */
LP.dockOn($('.e-hero'));

})();